import { Message } from 'element-ui';
import * as types from '../mutation-types';
import sendComment from '../../services/comments';

const state = {
  comments: [],
  isLoading: false,
};
const getters = {
  getComments: state => state.comments,
  getIsLoading: state => state.isLoading,
};

const mutations = {
  [types.SET_COMMENTS_LOADING](state, isLoading) {
    state.isLoading = isLoading;
  },
};

const actions = {
  setComment({ commit }, { poId, comment, mentions }) {
    const commentJson = { text: comment, mentions };
    commit(types.SET_COMMENTS_LOADING, true);
    sendComment(poId, commentJson).then(response => response.data).then((data) => {
      if (data.text) {
        Message.error('Message must have 500 characters or less');
      } else {
        commit(types.SET_PO_ITEM, data);
        Message.success('Message sent!');
      }
      commit(types.SET_COMMENTS_LOADING, false);
    }).catch((error) => {
      commit(types.SET_COMMENTS_LOADING, false);
      if (error.response.data.message) {
        Message.error(error.response.data.message);
      } else {
        Message.error('Something went wrong! Try again.');
      }
    });
  },
};

export default {
  state,
  getters,
  mutations,
  actions,
};



// WEBPACK FOOTER //
// ./src/store/modules/comments.js